import logo from './logo.svg';
import './App.css';
import SchoolSearch from "./components/SchoolSearch";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';


function App() {
  return (
    <div>
      <div class="row justify-content-center">
        <div class="col-sm-6">
          <h1>TRA CỨU HỌC PHÍ</h1>
        </div>
      </div>
      <SchoolSearch />
    </div>
  );
}

export default App;
